import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  getCurrentProfileSelect,
  PROFILE_KEY
} from '@gymaholic/packages'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import pushRouterAction from 'modules/router/actions/push'
import { logUtil } from 'packages/src'

export default function navigateToCurrentProfileAction (profileName) {
  return (dispatch, getState) => {
    const currentProfile = getCurrentProfileSelect(getState())
    const currentProfileName = profileName || getValueReduxUtil(currentProfile, PROFILE_KEY.NAME)
    const debugProps = {
      currentProfile,
      currentProfileName
    }
    logUtil('navigateToCurrentProfileAction').debug('[start] debugProps=', debugProps)

    if (!currentProfileName) {
      logUtil('navigateToCurrentProfileAction').debug('[noop] no name')
      return
    }

    dispatch(
      pushRouterAction({
        pathname: interpolateRouteUtil(ROUTE_PATH.ACCOUNT)
      })
    )
  }
}
